import {
  workflowEndcustomerOneUpgradeCuRouting
} from "./workflow-endcustomer-one-upgrade-cu/workflow-endcustomer-one-upgrade-cu.routing";
import {
  workflowEndcustomerOneDowngradeCuRouting
} from "./workflow-endcustomer-one-downgrade-cu/workflow-endcustomer-one-downgrade-cu.routing";
import {
  workflowEndcustomerOneUpgradeSlaRouting
} from "./workflow-endcustomer-one-upgrade-sla/workflow-endcustomer-one-upgrade-sla.routing";
import {
  workflowEndcustomerOneDowngradeSlaRouting
} from "./workflow-endcustomer-one-downgrade-sla/workflow-endcustomer-one-downgrade-sla.routing";
import {
  workflowEndcustomerOneTrialCreateRouting
} from "./workflow-endcustomer-one-trial-create/workflow-endcustomer-one-trial-create.routing";
import {
  workflowEndcustomerAddTrialPhonenumberRouting
} from "./workflow-endcustomer-add-trial-phonenumber/workflow-endcustomer-add-trial-phonenumber.routing";
import {
  workflowEndcustomerOneTariffRouting
} from "./workflow-endcustomer-one-tariff/workflow-endcustomer-one-tariff.routing";
import {
  workflowEndcustomerOneAvailabilityRouting
} from "./workflow-endcustomer-one-availability/workflow-endcustomer-one-availability.routing";
import {
  WorkflowEndcustomerOneAvailabilityOrderCancelRouting
} from "./workflow-endcustomer-one-availability-order-cancel/workflow-endcustomer-one-availability-order-cancel.routing";
import {
  WorkflowEndcustomerOneTariffOrderCancelRouting
} from "./workflow-endcustomer-one-tariff-order-cancel/workflow-endcustomer-one-tariff-order-cancel.routing";
import { workflowEndcustomerOneCancelPhonenumberRouting } from "./workflow-endcustomer-one-cancel-phonenumber/workflow-endcustomer-one-cancel-phonenumber.routing";
import { 
  workflowEndcustomerAiTariffRouting 
} from "./workflow-endcustomer-ai-tariff/workflow-endcustomer-ai-tariff.routing";
import { 
  WorkflowEndcustomerAiTariffOrderCancelRouting 
} from "./workflow-endcustomer-ai-tariff-order-cancel/workflow-endcustomer-ai-tariff-order-cancel.routing";

export const workflowEndcustomerRouting = [
  ...workflowEndcustomerOneUpgradeCuRouting,
  ...workflowEndcustomerOneUpgradeSlaRouting,
  ...workflowEndcustomerOneDowngradeCuRouting,
  ...workflowEndcustomerOneDowngradeSlaRouting,
  ...workflowEndcustomerOneTrialCreateRouting,
  ...workflowEndcustomerAddTrialPhonenumberRouting,
  ...workflowEndcustomerOneTariffRouting,
  ...workflowEndcustomerOneAvailabilityRouting,
  ...WorkflowEndcustomerOneAvailabilityOrderCancelRouting,
  ...WorkflowEndcustomerOneTariffOrderCancelRouting,
  ...workflowEndcustomerOneCancelPhonenumberRouting,
  ...workflowEndcustomerAiTariffRouting,
  ...WorkflowEndcustomerAiTariffOrderCancelRouting
]